<template>
    <div class="feature-container">
        <!-- features -->
        <section class="section">
            <h2 class="section-title"><i class="el-icon-finished"></i> {{ $t('feature.featuresTitle') }}</h2>
            <el-table
                :show-header="false"
                :data="featureData"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                @row-click="rowClick"
                class="feature-table"
                stripe>
                <el-table-column type="expand" width="50">
                    <template slot-scope="props">
                        <div class="expand-content">
                            <ul class="feature-list">
                                <li v-for="(item, index) in props.row.childrenFeatures" :key="index" v-html="item"></li>
                            </ul>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="feature">
                    <template slot-scope="scope">
                        <div class="feature-header-cell">
                            <i :class="scope.row.icon"></i>
                            <span class="feature-text-main">{{ scope.row.feature }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>

        <!-- Video -->
        <section class="section">
            <h2 class="section-title"><i class="el-icon-video-camera"></i> {{ $t('feature.demoTitle') }}</h2>
            <div class="video-wrapper">
                <iframe
                    src="https://www.youtube.com/embed/XYOjdKc05kk"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
            </div>
        </section>

        <!-- manual -->
        <section class="section">
            <h2 class="section-title"><i class="el-icon-notebook-2"></i> {{ $t('feature.manualTitle') }}</h2>
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" class="manual-col">
                    <el-card class="manual-card" shadow="hover">
                        <div slot="header" class="manual-header">
                            <span>{{ $t('feature.manualStd') }}</span>
                        </div>
                        <div class="manual-body">
                            <el-popover
                                placement="top-start"
                                :title="$t('feature.popoverStd')"
                                width="800"
                                trigger="hover">
                                <div class="popover-content" v-html="pdfStd"></div>
                                <el-button type="text" slot="reference" class="manual-link">
                                    <i class="el-icon-document"></i> {{ $t('feature.previewStd') }}
                                </el-button>
                            </el-popover>
                            <div class="manual-actions">
                                <el-link href="manual.pdf" target="_blank" type="primary" :underline="false">
                                    <i class="el-icon-download"></i> {{ $t('feature.openInNewWindow') }}
                                </el-link>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :xs="24" :sm="12" class="manual-col">
                    <el-card class="manual-card pro" shadow="hover">
                        <div slot="header" class="manual-header">
                            <span>{{ $t('feature.manualPro') }}</span>
                        </div>
                        <div class="manual-body">
                            <el-popover
                                placement="top-start"
                                :title="$t('feature.popoverPro')"
                                width="800"
                                trigger="hover">
                                <div class="popover-content" v-html="pdfPro"></div>
                                <el-button type="text" slot="reference" class="manual-link">
                                    <i class="el-icon-document-add"></i> {{ $t('feature.previewPro') }}
                                </el-button>
                            </el-popover>
                            <div class="manual-actions">
                                <el-link href="manual_pro.pdf" target="_blank" type="success" :underline="false">
                                    <i class="el-icon-download"></i> {{ $t('feature.openInNewWindow') }}
                                </el-link>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </section>
    </div>
</template>

<script>
export default {
  data () {
    return {
      pdfStd: "<embed src='manual.pdf' type='application/pdf' width='100%' height='600px'>",
      pdfPro: "<embed src='manual_pro.pdf' type='application/pdf' width='100%' height='600px'>",
      expands: []
    }
  },
  computed: {
    featureData () {
      return this.$t('feature.items')
    }
  },
  methods: {
    getRowKeys (row) {
      return row.id
    },
    rowClick (row) {
      if (row.id === this.expands[0]) {
        this.expands = []
      } else {
        this.expands = [row.id]
      }
    }
  }
}
</script>

<style scoped>
.feature-container {
    padding: 20px;
}

.section {
    margin-bottom: 50px;
}

.section-title {
    font-size: 22px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 25px;
    padding-bottom: 4px;
    display: inline-block;
}

.section-title i {
    color: #409EFF;
    margin-right: 8px;
}

.feature-table {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.feature-header-cell {
    padding: 10px 0;
    cursor: pointer;
}

.feature-header-cell i {
    font-size: 20px;
    color: #409EFF;
    margin-right: 15px;
}

.feature-text-main {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.expand-content {
    padding: 10px 40px;
    background-color: #fcfcfc;
}

.feature-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.feature-list li {
    margin-bottom: 12px;
    font-size: 15px;
    color: #606266;
    position: relative;
    padding-left: 20px;
}

.feature-list li::before {
    content: "•";
    color: #409EFF;
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}

.video-wrapper {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
    height: 0;
    overflow: hidden;
    max-width: 1000px;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
    margin: 0 auto;
}

.video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.manual-col {
    margin-bottom: 20px;
}

.manual-card {
    border-radius: 12px;
    border: 1px solid #ebeef5;
    transition: all 0.3s ease;
}

.manual-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.manual-header {
    font-weight: bold;
    font-size: 18px;
    color: #409EFF;
}

.manual-card.pro .manual-header {
    color: #67C23A;
}

.manual-body {
    text-align: center;
    padding: 10px 0;
}

.manual-link {
    font-size: 16px;
    margin-bottom: 15px;
}

.manual-actions {
    margin-top: 10px;
}

.popover-content {
    background: #f0f2f5;
    padding: 5px;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .feature-container {
        padding: 15px;
    }
    .section-title {
        font-size: 18px;
    }
    .feature-text-main {
        font-size: 14px;
    }
}
</style>
